import { render, staticRenderFns } from "./VisualizadorPDF.vue?vue&type=template&id=7ab91aac"
import script from "./VisualizadorPDF.vue?vue&type=script&lang=js"
export * from "./VisualizadorPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
